export default __webpack_public_path__ + "Visa.1b4c198f.svg";